import React from 'react'
import { motion } from "framer-motion"
const Banner = () => {
  return (
    <motion.img className='w-full h-48 lg:h-72 object-cover' src='/image/banner/1.jpg' />
  )
}

export default Banner